import { AtkNav } from "../autotractor/AtkNav";
import { Button, Paper } from "@mui/material";
import {
  getImplementArchetypesPath,
  getImplementsPath,
  getTractorArchetypesPath,
  getTractorsPath,
} from "portal/utils/routing";
import { Header } from "portal/components/header/Header";
import { Page } from "portal/components/Page";
import { useCanEditArchetypes } from "./permissions";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface EquipmentPageProps {}
export const EquipmentPage: FC<EquipmentPageProps> = () => {
  const { t } = useTranslation();
  const canEditArchetypes = useCanEditArchetypes();
  const navigate = useNavigate();
  const buttonClassName = canEditArchetypes ? "" : "col-span-full";

  return (
    <Page>
      <Header title={t("models.equipment.equipment")}>
        <AtkNav />
      </Header>
      <div className="flex gap-4">
        <div className="flex flex-col w-full gap-4">
          <Paper className="p-4 grid grid-cols-2 gap-4">
            <Button
              variant="contained"
              onClick={() => navigate(getTractorsPath())}
              className={buttonClassName}
            >
              {t("views.autotractor.equipment.tractorLibrary")}
            </Button>
            {canEditArchetypes && (
              <Button
                variant="contained"
                onClick={() => navigate(getTractorArchetypesPath())}
                className={buttonClassName}
              >
                {t("views.autotractor.equipment.tractorArchetypeLibrary")}
              </Button>
            )}
          </Paper>
          <Paper className="p-4 grid grid-cols-2 gap-4">
            <Button
              variant="contained"
              onClick={() => navigate(getImplementsPath())}
              className={buttonClassName}
            >
              {t("views.autotractor.equipment.implementLibrary")}
            </Button>
            {canEditArchetypes && (
              <Button
                variant="contained"
                onClick={() => navigate(getImplementArchetypesPath())}
                className={buttonClassName}
              >
                {t("views.autotractor.equipment.implementArchetypeLibrary")}
              </Button>
            )}
          </Paper>
        </div>
      </div>
    </Page>
  );
};
